import { combineReducers } from 'redux';
import uiReducer from './ui.reducer';
import featureReducer from './feature.reducer';

export default () => combineReducers({
  feature: featureReducer,
  ui: uiReducer
});

